<template>
  <!--新增对话框-->
  <el-dialog
    :before-close="handleClose"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    append-to-body
    title="充值"
    width="50%"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editFormRules"
      class="demo-editForm"
      label-width="120px"
    >
      <el-form-item label="金额" label-width="120px" prop="money">
        <el-input
          v-model="editForm.money"
          autocomplete="off"
          type="number"
          min="0"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" label-width="120px" prop="remark">
        <el-input
          v-model="editForm.remark"
          :rows="8"
          autocomplete="off"
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item align="center">
        <el-button type="primary" @click="submitForm('editForm')"
          >充值</el-button
        >
        <el-button @click="resetForm('editForm')">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  name: "chongzhi",
  components: {},
  data() {
    return {
      dialogVisible: false,
      userId: null,
      editForm: {
        money: "",
        remark: "",
        userId: "",
      },
      editFormRules: {
        money: [
          {
            required: true,
            message: "请输入充值金额",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.resetForm("editForm");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/admin/balanceRecord/recharge", this.editForm)
            .then((res) => {
              this.handleClose();
              this.$emit("shuaxin");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    init(id) {
      this.dialogVisible = true;
      this.editForm.userId = id;
    },
  },
};
</script>

<style scoped></style>
